export const environment = {
  production: false,
  version: {
    WEB_LOGIN: '2026.11.04--15.57-dev',
    WEB_ADMIN: '2026.11.04--15.57-dev',
    WEB_CARRIER: '2026.11.04--15.57-dev',
    WEB_CUSTOMER: '2026.11.04--15.57-dev',
  },
  buildInfo: { version: '2.58.3', builtAt: '2026.11.04--15.58', commit: '14dc3dec' },
  sentry: {
    dsn: 'https://de0c6183d13083a9a954729b6c56bb2b@o4511370511712256.ingest.us.sentry.io/4512202659266560',
    environment: 'dev',
    tracesSampleRate: 1.0,
  },
  apiUrl: 'https://api.fr8bot.devserver.cc',
  wsUrl: 'api.fr8bot.devserver.cc',
  frontendUrl: {
    login: 'https://fr8bot.devserver.cc',
    admin: 'https://admin.fr8bot.devserver.cc',
    carrier: 'https://carrier.fr8bot.devserver.cc',
    customer: 'https://customer.fr8bot.devserver.cc',
  },
};
